"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./utils/freshdesk-widget");
/* Controllers */
angular.module('callX')
    .controller('AppCtrl', ['$scope', '$modal', '$window', 'UserService', '$state', '$location', 'DateService',
    function ($scope, $modal, $window, UserService, $state, $location, DateService) {
        // add 'ie' classes to html
        var isIE = !!navigator.userAgent.match(/MSIE/i);
        isIE && angular.element($window.document.body).addClass('ie');
        isSmartDevice($window) && angular.element($window.document.body).addClass('smart');
        // config
        $scope.app = {
            name: 'CallX Logo',
            version: '2.1.0',
            // for chart colors
            color: {
                primary: '#7266ba',
                info: '#23b7e5',
                success: '#27c24c',
                warning: '#fad733',
                danger: '#f05050',
                light: '#e8eff0',
                dark: '#3a3f51',
                black: '#1c2b36'
            },
            settings: {
                themeID: 1,
                navbarHeaderColor: 'bg-black',
                navbarCollapseColor: 'bg-white-only',
                asideColor: 'bg-black',
                headerFixed: true,
                asideFixed: false,
                asideFolded: false,
                asideDock: false,
                container: false
            }
        };
        SentryUtils.init();
        // save settings to local storage
        // if ( angular.isDefined($localStorage.settings) ) {
        //   $scope.app.settings = $localStorage.settings;
        // } else {
        //   $localStorage.settings = $scope.app.settings;
        // }
        // $scope.$watch('app.settings', function(){
        //   if( $scope.app.settings.asideDock  &&  $scope.app.settings.asideFixed ){
        //     // aside dock and fixed must set the header fixed.
        //     $scope.app.settings.headerFixed = true;
        //   }
        //   // for box layout, add background image
        //   $scope.app.settings.container ? angular.element('html').addClass('bg') : angular.element('html').removeClass('bg');
        //   // save to local storage
        //   $localStorage.settings = $scope.app.settings;
        // }, true);
        function isSmartDevice($window) {
            // Adapted from http://www.detectmobilebrowsers.com
            var ua = $window['navigator']['userAgent'] || $window['navigator']['vendor'] || $window['opera'];
            // Checks for iOs, Android, Blackberry, Opera Mini, and Windows mobile devices
            return (/iPhone|iPod|iPad|Silk|Android|BlackBerry|Opera Mini|IEMobile/).test(ua);
        }
        var TempDateObj = DateService.getDateObj();
        $scope.$on('dateObjUpdate', function (event, dateObj) {
            TempDateObj = dateObj;
        });
        $scope.numeral = window.numeral;
        $scope.numeralFormat = function (number, format) {
            if (typeof format == "undefined")
                format = 'number';
            switch (format) {
                case 'percent':
                    return $scope.numeral(number).format('0[.]00%');
                // break;
                case 'usd':
                    if (number > 999999) {
                        return $scope.numeral(number).format('($0,0[.]00 a)');
                    }
                    else {
                        return $scope.numeral(number).format('($0,0[.]00)');
                    }
                // break;
                default:
                    if (number > 999999) {
                        return $scope.numeral(number).format('0,0[.]00 a');
                    }
                    else {
                        return $scope.numeral(number).format('0,0[.]00');
                    }
                // break;
            }
        };
        $scope.secondsToMinutes = function (sec) {
            var sec_num = parseInt(sec, 10); // don't forget the second param
            var hours = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = sec_num - (hours * 3600) - (minutes * 60);
            if (hours < 10) {
                hours = "0" + hours;
            }
            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            if (seconds < 10) {
                seconds = "0" + seconds;
            }
            var time = (parseInt(hours) > 0) ? (hours + ':' + minutes + ':' + seconds) : (minutes + ':' + seconds);
            return time;
        };
        $scope.plotBy = function (activeDate) {
            if (activeDate === 'today' || activeDate === 'yesterday') {
                return 'hour';
            }
            else if (activeDate === 'thirty-days' || activeDate === 'seven-days' || activeDate === 'this-month') {
                return 'day';
            }
            else if (activeDate === 'this-year') {
                return 'month';
            }
            else {
                return 'hour';
            }
        };
        $scope.capitalize = function (text) {
            return String(text).replace(/(?:^|\s)\S/g, function (a) { return a.toUpperCase(); });
        };
        $scope.formatDate = function (date) {
            var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            var d = new Date(date);
            return monthNames[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear();
        };
        $scope.formatDateTwo = function (date) {
            var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            var d = moment(date).toDate();
            var n = d.valueOf();
            return n;
        };
        $scope.pad = function (num, size) {
            var s = num + "";
            while (s.length < size)
                s = "0" + s;
            return s;
        };
        $scope.formatPhoneNumber = function (input, format, withCountryCode) {
            withCountryCode = typeof withCountryCode == "undefined" ? false : withCountryCode;
            if (typeof format == "undefined") {
                format = "XXX-XXX-XXXX";
            }
            if (withCountryCode) {
                format = "XX-XXX-XXX-XXXX";
            }
            input = $scope.pad(input, 12);
            if (input.length > 10 && !withCountryCode) {
                // remove the country code
                var _pos = Math.abs(input.length - 10);
                input = input.substring(_pos);
            }
            // Strip non-numeric characters
            var digits = input.replace(/\D/g, '');
            ///var digits = input.replace('\-');
            // Replace each "X" with the next digit
            var count = 0;
            return format.replace(/X/g, function () {
                return digits.charAt(count++);
            });
        };
        $scope.formatPhoneNumberPub = function (input, format, withCountryCode) {
            withCountryCode = typeof withCountryCode == "undefined" ? false : withCountryCode;
            if (typeof format == "undefined") {
                format = "XXX-XXX-XXXX";
            }
            if (withCountryCode) {
                format = "XX-XXX-XXX-XXXX";
            }
            input = $scope.pad(input, 12);
            if (input.length > 10 && !withCountryCode) {
                // remove the country code
                var _pos = Math.abs(input.length - 10);
                input = input.substring(_pos);
            }
            // Strip non-numeric characters
            var digits = input;
            ///var digits = input.replace('\-');
            // Replace each "X" with the next digit
            var count = 0;
            return format.replace(/X/g, function () {
                return digits.charAt(count++);
            });
        };
        $scope.addCurrencyToLabel = function (val, axis) {
            var num = parseInt(val);
            return "$" + num;
        };
        $scope.$on('currentUserUpdate', function (event, currentUserData) {
            $scope.currentUserData = currentUserData;
        });
        $scope.currentUserData = UserService.getCurrentUserData();
        $scope.$on('$locationChangeSuccess', function (event) {
            $scope.currentRoute = $location.path();
        });
        $scope.openCopyConfirmationModal = function () {
            var dialogInst = $modal.open({
                templateUrl: 'tpl/blocks/terms_of_service.html',
                controller: 'TOSCtrl',
                size: 'lg'
            });
        };
        $scope.logout = function () {
            var callbacks = {
                success: function (data) {
                    if (data.statusCode == 200) {
                        $state.go('access.login');
                    }
                    else {
                        /*toaster.pop('error', 'Error', data.message);*/
                    }
                },
                failure: function (data) {
                    /*toaster.pop('error', 'Error', data.message);*/
                }
            };
            UserService.logout($scope.currentUserData.user_id, callbacks);
        };
    }]);
